import React from "react";
import { FooterContainer, FooterLinks, FooterLogo } from "@thrivetribe/mvf.ui.organisms.footer";
import { Logo, MvFLogoSvg } from "@thrivetribe/mvf.assets.logo";
import { footerLinks } from "configs/UrlConfig";

export const Footer = () => {
  return (
    <FooterContainer>
      <FooterLogo logo={<Logo icon={MvFLogoSvg} url="/" />} />
      <FooterLinks links={footerLinks} />
    </FooterContainer>
  );
};
